import { UpdateTeamRequest, GetTeamsRequest } from 'api';
import { atom, selector } from 'recoil';

export const teamPageSizeState = atom<number>({
  key: 'teamPageSizeState',
  default: 10,
});

export const teamPageNumberState = atom<number>({
  key: 'teamPageNumberState',
  default: 1,
});

export const teamSortByDescendingFilterState = atom<boolean | undefined>({
  key: 'teamSortByDescendingFilterState',
  default: undefined,
});

export const teamSortByColumnFilterState = atom<string>({
  key: 'teamSortByColumnFilterState',
  default: '',
});

export const teamSearchState = atom<string>({
  key: 'teamSearchState',
  default: '',
});

export const teamEditingRowIdState = atom<number | undefined>({
  key: 'teamEditingRowIdState',
  default: undefined,
});

export const teamEditingRowTeamNameState = atom<string>({
  key: 'teamEditingRowTeamNameState',
  default: '',
});

export const teamEditingRowEmailState = atom<string>({
  key: 'teamEditingRowEmailState',
  default: '',
});

export const teamEditingRowBackofficeCodeState = atom<string>({
  key: 'teamEditingRowBackofficeCodeState',
  default: '',
});

export const teamsGetRequestState = selector<GetTeamsRequest>({
  key: 'teamsGetRequest',
  get: ({ get }) => {
    const sortByDesc = get(teamSortByDescendingFilterState);
    const sortByColumn = get(teamSortByColumnFilterState);

    return {
      pageSize: get(teamPageSizeState),
      pageNumber: get(teamPageNumberState),
      nameOrEmailSearchText: get(teamSearchState),
      organisationName: '',
      ...(sortByColumn && {
        sortByValue: sortByColumn,
        sortBy: sortByDesc ? 'Descending' : 'Ascending',
      }),
    };
  },
});

export const teamUpdateRequestState = selector<UpdateTeamRequest>({
  key: 'teamUpdateRequestState',
  get: ({ get }) => {
    const request: UpdateTeamRequest = {
      id: 0,
      teamName: get(teamEditingRowTeamNameState),
      backOfficeTeamName: get(teamEditingRowBackofficeCodeState),
      email: get(teamEditingRowEmailState),
    };
    return request;
  },
});
